import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withStateHandlers, withHandlers } from 'recompose';
import { changeWidgetJSProp, updateWidgetJSPropField } from '../../actions';
import _ from 'lodash';
import { IconButton, Divider, SelectField, FlatButton, Toggle, MenuItem } from 'material-ui';
import IconDelete from 'material-ui/svg-icons/navigation/close';
import IconAdd from 'material-ui/svg-icons/content/add-circle-outline';

const AreaManipulations = ({ id, onDelete, name, ...props }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '10px 0 ' }}>
        {/* <pre>{JSON.stringify(props, null, 4)}</pre> */}

        <img src={props.url} style={{ width: 50, height: 50, objectFit: 'cover' }} />
        <span style={{ padding: 10, flexGrow: 1 }}>{name}</span>
        <IconButton
            onClick={() => {
                onDelete(id, null);
            }}
        >
            <IconDelete color="#fff" />
        </IconButton>
    </div>
);

export default compose(
    withStateHandlers(null, {
        enterEditMode: () => id => ({
            propKey: id,
        }),
    }),
    connect(
        ({ editor }) => {
            const areas = _.chain(editor.widgetProps)
                .keys()
                .filter(k => k.indexOf('area') === 0 && editor.widgetProps[k] && !_.isEmpty(editor.widgetProps[k]))
                .map(key => ({ key, ...editor.widgetProps[key] }))
                .value();
            return {
                areas,
                dnd: (editor.widgetProps && editor.widgetProps.dnd) || {},
            };
        },
        {
            changeWidgetJSProp,
            updateWidgetJSPropField,
        },
    ),
    withHandlers({
        action: ({ im }) => delta => {},
    }),

    lifecycle({
        componentDidMount() {
            // window.addEventListener('WDP_IM', this.onManipulation.bind(this), false);
        },
    }),
)(({ areas = [], dnd, changeWidgetJSProp }) => {
    return (
        <div>
            {areas.map((area, index) => (
                <AreaManipulations
                    key={area.key}
                    id={area.key}
                    {...area}
                    name={`${index}. layer`}
                    onDelete={() => {
                        const update = {};
                        update[area.key] = null;
                        changeWidgetJSProp(update);
                    }}
                />
            ))}

            {areas.length < 5 && (
                <FlatButton
                    icon={<IconAdd />}
                    label="Add custom background"
                    onClick={() => {
                        const update = {};
                        update[`area${areas.length + 1}`] = { id: `area${areas.length + 1}` };
                        changeWidgetJSProp(update);
                    }}
                />
            )}
            <Divider style={{ marginTop: 15, marginBottom: 15 }} />
            {areas.length >= 2 && (
                <div>
                    <SelectField
                        floatingLabelText="Show backgrounds"
                        value={dnd.direction || 'row'}
                        onChange={(e, index, direction) => {
                            changeWidgetJSProp({
                                dnd: {
                                    ...dnd,
                                    direction,
                                },
                            });
                        }}
                    >
                        {[['row', 'Horizontal'], ['column', 'Vertical']].map(([k, t]) => {
                            return <MenuItem key={k} value={k} primaryText={t} />;
                        })}
                    </SelectField>

                    <Toggle
                        label="Display border"
                        checked={dnd.border}
                        style={{ marginTop: 15 }}
                        onToggle={(e, isChecked) => {
                            changeWidgetJSProp({
                                dnd: {
                                    ...dnd,
                                    border: isChecked,
                                },
                            });
                        }}
                    />
                    <Divider style={{ marginTop: 15, marginBottom: 15 }} />
                </div>
            )}
        </div>
    );
});



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/controls/BGRAreasControls.js
 **/